import Service from "../../AuthService";
const ProduceReport = {
    getReport(page) {
        return Service.get("/produce-report?page="+page);
    },
    updateReport(id) {
        return Service.put("/produce-report/" + id);
    },
    createReport() {
        return Service.post("/produce-report");
    },
    deleteReport(id) {
        return Service.delete("/produce-report/" + id);
    }
};
export default ProduceReport;
